
<template>
  <div class="ping">
            
  </div>
</template>

<script>


export default {
  name: 'ping',
  computed: {
  },
  data () {
    return {
     
    }
  },
  created() {

  },
  mounted () {
    
  },
  methods: {
   
  },
  components: {

  }
}
</script>

<style scoped>
</style>
